import React from 'react';
import { FacebookIcon, LinkedinIcon, InstagramIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#121c53] text-white py-12 px-6 md:px-12 lg:px-16" data-id="element-92">
      <div className="max-w-7xl mx-auto" data-id="element-93">
        <div className="grid md:grid-cols-3 gap-8 mb-8" data-id="element-94">
          {/* Logo and Tagline */}
          <div data-id="element-95">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qg3u3nCKM719Xao3tc39be/logo_transparent_clc_alb.png" alt="cautlocuinta.ro" className="h-20 mb-4" data-id="element-96" />
            <p className="text-gray-300 text-sm" data-id="element-97">
              Real Estate Agency – Cine caută, găsește.
            </p>
          </div>
          {/* Contact Info */}
          <div data-id="element-98">
            <h3 className="font-semibold text-lg mb-4" data-id="element-99">Contact</h3>
            <div className="space-y-2 text-gray-300 text-sm" data-id="element-100">
              <p data-id="element-101">Ștefan Bira: 0760.243.210</p>
              <p data-id="element-102">Simona Stancu: 0722.225.574</p>
              <p data-id="element-103">Email: contact@cautlocuinta.ro</p>
            </div>
          </div>
          {/* Social Media */}
          <div data-id="element-104">
            <h3 className="font-semibold text-lg mb-4" data-id="element-105">Urmărește-ne</h3>
            <div className="flex gap-4" data-id="element-106">
              <a href="https://www.facebook.com/share/1BgZ4zYKJN/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" className="p-3 bg-white/10 hover:bg-white/20 rounded-full transition-colors" aria-label="Facebook" data-id="element-107">
                <FacebookIcon className="w-5 h-5" data-id="element-108" />
              </a>
              <a href="https://www.linkedin.com/company/cautlocuinta-ro/" target="_blank" rel="noopener noreferrer" className="p-3 bg-white/10 hover:bg-white/20 rounded-full transition-colors" aria-label="LinkedIn" data-id="element-109">
                <LinkedinIcon className="w-5 h-5" data-id="element-110" />
              </a>
              <a href="https://www.instagram.com/cautlocuinta.ro?igsh=YThoM2h3ZzB1OXhi" target="_blank" rel="noopener noreferrer" className="p-3 bg-white/10 hover:bg-white/20 rounded-full transition-colors" aria-label="Instagram" data-id="element-111">
                <InstagramIcon className="w-5 h-5" data-id="element-112" />
              </a>
            </div>
          </div>
        </div>
        {/* Copyright */}
        <div className="pt-8 border-t border-white/10 text-center text-gray-400 text-sm" data-id="element-113">
          <p data-id="element-114">Copyright © cautlocuinta.ro 2025. Toate drepturile rezervate.</p>
        </div>
      </div>
    </footer>;
}